/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EditionEnum = 'STANDARD' | 'ADVANCED' | 'ENTERPRISE';

export const EditionEnum = {

    STANDARD: 'STANDARD' as EditionEnum,

    ADVANCED: 'ADVANCED' as EditionEnum,

    ENTERPRISE: 'ENTERPRISE' as EditionEnum
};

